/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Pagination, Setter, StorageLocation, StorageLocationDetailed } from "../../utils/Interfaces";
import { buildGetRequest, getHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AxiosResponse } from "axios";

// TODO Deprecate this function. This is still required for the material transfers page.
export function storageLocationDetails(
    storageLocationId: number,
    dispatch: Dispatch<AnyAction>,
    setStorageLocationDetails: Setter<StorageLocationDetailed>
) {
    getHandler<StorageLocationDetailed>(
        `/api/locations/storage-locations/details/${storageLocationId}`,
        dispatch,
        (response: AxiosResponse<StorageLocationDetailed, any>) => {
            setStorageLocationDetails(response.data);
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function getStorageLocationDetails(storageLocationId: number) {
    return buildGetRequest<StorageLocationDetailed>(`/api/locations/storage-locations/details/${storageLocationId}`);
}

export function getAllStorageLocations() {
    return buildGetRequest<Pagination<StorageLocation>>(`/api/locations/storage-locations/list-all`);
}
